import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  TablePagination,
  TextField,
  Typography,
  IconButton,
  Tooltip,
  Drawer,
  Button,
  Grid,
  Autocomplete,
  FormControl,
  Select,
  MenuItem,
  LinearProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
} from "@mui/material";

import FormatSizeIcon from "@mui/icons-material/FormatSize";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import VisibilityIcon from "@mui/icons-material/Visibility";

import { QuillDeltaToPdfConverter } from "quill-to-pdf";
import pdfMake from "pdfmake/build/pdfmake";
import noData from "../../images/noData.jpg";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import verifyImg from "../../images/check-mark.png";
import blankA4 from "../../pdf/blankA4.pdf";
import { PDFDocument, StandardFonts, rgb } from "pdf-lib";
import html2canvas from "html2canvas";
import fontkit from "@pdf-lib/fontkit";
import BarcodeFont from "./free3of9/fre3of9x.ttf";
import Avatar from "@mui/material/Avatar";
import Chip from "@mui/material/Chip";
import QRCode from "qrcode";
import RefreshIcon from "@mui/icons-material/Refresh";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { BASE_URL } from "../../constants";
import { appendSanitizedReportHtml } from "../../utils/reportSanitizer";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useRecoilState, useRecoilValue } from "recoil";
import { authState } from "../../recoil/authAtom";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CircularProgress from "@mui/material/CircularProgress";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CircleIcon from "@mui/icons-material/Circle";
import { useNavigate } from "react-router-dom";
import JsBarcode from "jsbarcode";

import {
  radiologyReportState,
  radiologyReportsLoadedState,
  rowLoadingState,
  formattedFromDateState,
  formattedToDateState,
  fromDateState,
  toDateState,
} from "../../recoil/radiologyReportState";
import { toast } from "react-toastify";
const getFormattedCurrentDate = () => {
  const today = new Date();
  const day = today.getDate();
  const month = today.toLocaleString("en-US", { month: "long" });
  const year = today.getFullYear();
  const formattedDay = day < 10 ? `0${day}` : day;

  return `${month} ${formattedDay}, ${year}`;
};
const RadiologyReports = ({ doctors, setDoctors, centers, setCenters }) => {
  // const [radiologies, setRadiologies] = useState([]);
  const navigate = useNavigate();
  const user = useRecoilValue(authState);
  const [loading, setLoading] = useState(false);
  const [loadingStates, setLoadingStates] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [pdfTemplate, setPdfTemplate] = useState("");
  const [uploadingRadiologyId, setUploadingRadiologyId] = useState(null);
  const [selectedRadiologyToUpload, setSelectedRadiologyToUpload] =
    useState(null);
  const [selectedReportToUpload, setSelectedReportToUpload] = useState(null);
  const getFormattedDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // Extracts YYYY-MM-DD from ISO format
  };
  // const [fromDate, setFromDate] = useState(getFormattedDate());
  // const [toDate, setToDate] = useState(getFormattedDate());
  // const [formattedFromDate, setFormattedFromDate] = useState(
  //   getFormattedCurrentDate()
  // );
  // const [formattedToDate, setFormattedToDate] = useState(
  //   getFormattedCurrentDate()
  // );

  const [radiologyReportsLoaded, setRadiologyReportsLoaded] = useRecoilState(
    radiologyReportsLoadedState,
  );
  console.log("selectedRadiologyToUpload", selectedRadiologyToUpload);
  console.log("selectedReportToUpload", selectedReportToUpload);
  const [radiologyReport, setRadiologyReport] =
    useRecoilState(radiologyReportState);
  const [fromDate, setFromDate] = useRecoilState(fromDateState);
  const [toDate, setToDate] = useRecoilState(toDateState);
  const [rowLoading, setRowLoading] = useRecoilState(rowLoadingState);
  const [formattedFromDate, setFormattedFromDate] = useRecoilState(
    formattedFromDateState,
  );
  const [formattedToDate, setFormattedToDate] =
    useRecoilState(formattedToDateState);

  const [open, setOpen] = useState(false);
  const [size, setSize] = useState("small");

  const fontSizeMap = {
    small: 15,
    medium: 18,
    large: 21,
  };
  const formatDateToReadableString = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const day = date.getDate();
    const month = date.toLocaleString("en-US", { month: "long" });
    const year = date.getFullYear();
    const formattedDay = day < 10 ? `0${day}` : day;
    return `${month} ${formattedDay}, ${year}`;
  };
  const showAgeInReport = (dob) => {
    const birthDate = dayjs(dob, "MMMM DD, YYYY");
    const today = dayjs();

    const years = today.diff(birthDate, "year");
    const months = today.diff(birthDate.add(years, "year"), "month");
    const days = today.diff(
      birthDate.add(years, "year").add(months, "month"),
      "day",
    );
    return `${years}Y ${months}M ${days}D`;
  };

  function formatDate(dateStr) {
    const date = new Date(dateStr);
    const day = date.getDate();
    const month = date.toLocaleString("en-US", { month: "short" }); // "Feb"
    const year = date.getFullYear().toString().slice(-2); // "25"
    return `${day}-${month}-${year}`;
  }
  function formatDateTime(isoString) {
    const date = new Date(isoString);
    const day = date.getDate();
    const month = date.toLocaleString("en-US", { month: "short" }); // "Feb"
    const year = date.getFullYear().toString().slice(-2); // "25"
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = String(hours % 12 || 12).padStart(2, "0"); // Ensure 2-digit hours
    const formattedMinutes = String(minutes).padStart(2, "0"); // Ensure 2-digit minutes

    return `${day}-${month}-${year} ${formattedHours}:${formattedMinutes} ${ampm}`;
  }
  const fetchPdfTemplate = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}api/user/common/get-pdfTemplate`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const data = await response.json();
      console.log(data);
      setPdfTemplate(data.pdf.orgReportPdfUrl);
    } catch (error) {}
  };

  const [radiologyCache, setRadiologyCache] = useState({});
  const [totalCount, setTotalCount] = useState(0);
  const fetchAllRadiology = async (
    page = 0,
    limit = 10,
    query = "",
    fromDateParam = formattedFromDate,
    toDateParam = formattedToDate,
  ) => {
    // ================== ✅ DATE RANGE VALIDATION ==================
    if (formattedFromDate && formattedToDate) {
      const from = new Date(formattedFromDate);
      const to = new Date(formattedToDate);

      const diffTime = Math.abs(to - from);
      const diffDays = diffTime / (1000 * 60 * 60 * 24);

      if (diffDays > 92) {
        toast.error("You can select maximum 3 months date range");
        setRowLoading(false);
        return;
      }
    }

    try {
      setRowLoading(true);

      const endpoint = query
        ? `${BASE_URL}api/user/radiology/search-reports?query=${encodeURIComponent(
            query,
          )}&page=${page}&limit=${limit}&startDate=${fromDateParam}&endDate=${toDateParam}`
        : `${BASE_URL}api/user/radiology/get-radiology-reports?page=${page}&limit=${limit}&startDate=${fromDateParam}&endDate=${toDateParam}`;

      const response = await fetch(endpoint, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();

      if (result.success) {
        const reqData = result.data?.map((path) => ({
          _id: path._id,
          invoice: path?.invoice?.invoiceId,
          billingDate: path?.invoice?.billingDate,
          billingTime: path?.invoice?.createdAt,
          doctorName: path?.doctorId?.name,
          patientName: path?.patientId?.name,
          report: path?.result,
          sampleCollectedDate: path?.sampleCollectedDate,
          sampleCollectedTime: path?.sampleCollectedTime,
          createdAt: path?.createdAt,
          patientId: path?.patientId,
          doctorId: path?.doctorId,
          centreId: path?.invoice?.centerId,
          reportFileUrls: path?.reportFileUrls,
          overallStatus: path?.overallStatus,
          signatoryDoctor: path?.doctorSignatory,
          techSignatory: path?.techSignatory,
        }));

        const cacheKey = `${query}_${page}_${limit}_${fromDateParam}_${toDateParam}`;

        setRadiologyCache((prev) => ({
          ...prev,
          [cacheKey]: {
            data: reqData,
            totalCount: result.totalCount,
          },
        }));

        setRadiologyReport(reqData);
        setTotalCount(result.totalCount || reqData.length);
        setRadiologyReportsLoaded(true);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong!");
    } finally {
      setRowLoading(false);
    }
  };

  const [radioLayout, setRadioLayout] = useState("");
  const fetchRadioLayout = async () => {
    try {
      const response = await fetch(`${BASE_URL}api/user/radiology/layout`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      setRadioLayout(data?.layout);
    } catch (error) {}
  };

  useEffect(() => {
    //fetchAllRadiology();
    fetchPdfTemplate();
    fetchRadioLayout();
  }, []);

  useEffect(() => {
    const cacheKey = `${searchQuery}_${page}_${rowsPerPage}_${formattedFromDate}_${formattedToDate}`;

    if (radiologyCache[cacheKey]) {
      setRadiologyReport(radiologyCache[cacheKey].data);
      setTotalCount(radiologyCache[cacheKey].totalCount);
    } else {
      fetchAllRadiology(
        page,
        rowsPerPage,
        searchQuery,
        formattedFromDate,
        formattedToDate,
      );
    }
  }, [page, rowsPerPage, searchQuery]);

  const handleReload = () => {
    fetchAllRadiology();
  };

  // Pagination Handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Search Filter
  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
    setPage(0);
  };

  function groupReportsPreservingData(data) {
    return data?.map((entry) => {
      const deptMap = new Map();

      entry?.report?.forEach((report) => {
        const testDept = report?.testId?._id?.testDept;

        if (!deptMap.has(testDept)) {
          deptMap.set(testDept, []);
        }

        deptMap.get(testDept).push(report);
      });

      const groupedReports = Array.from(deptMap.entries()).map(
        ([testDept, items]) => {
          // Find matching url from reportFileUrls
          const matchingUrlObj = entry?.reportFileUrls?.find(
            (urlObj) => urlObj?.testDept === testDept,
          );

          return {
            testDept,
            items,
            url: matchingUrlObj ? matchingUrlObj.url : "", // Attach url (empty if not found)
          };
        },
      );

      return {
        ...entry,
        report: groupedReports,
      };
    });
  }

  // console.log(222222, groupReportsPreservingData(radiologies));
  const r = groupReportsPreservingData(radiologyReport);
  const paginatedRadiologies = r; //radiologyReport;

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
    setSelectedPatient(null);
  };
  const calculateAge = (dob) => {
    if (!dob) return "Enter a valid DOB";
    const birthDate = dayjs(dob, "DD-MM-YYYY");
    const now = dayjs();
    const years = now.diff(birthDate, "year");
    const months = now.diff(birthDate.add(years, "year"), "month");
    return `${years} years and ${months} months`;
  };

  const handleDateChange = (newValue) => {
    const date = dayjs(newValue).format("DD-MM-YYYY");
    console.log("@@@", date);
    if (selectedPatient.age === "") {
      return setSelectedPatient({ ...selectedPatient, dob: date });
    } else {
      return setSelectedPatient({
        ...selectedPatient,
        dob: date,
        age: "",
      });
    }
  };

  const handleAgeChange = (e) => {
    if (selectedPatient.dob === "") {
      return setSelectedPatient({
        ...selectedPatient,
        age: e.target.value,
      });
    } else {
      return setSelectedPatient({
        ...selectedPatient,
        age: e.target.value,
        dob: "",
      });
    }
  };

  const handleSubmitEdit = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}api/user/radiology-update/${selectedPatient._id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(selectedPatient),
        },
      );
      const data = await response.json();
      console.log(data);
      if (data.success) {
        alert(data.message); // Show success message to the user
        const updatedPatients = radiologyReport.map((radiology) =>
          radiology._id === selectedPatient._id ? selectedPatient : radiology,
        );
        setRadiologyReport(updatedPatients);
        handleCloseDrawer();
      } else {
        alert(`Error: ${data.message}`); // Show error message to the user
      }
    } catch (error) {
      alert("An unexpected error occurred while updating the radiology.");
    }
  };
  const getColorTitle = (status) => {
    const result = [];
    if (status === 0) {
      result.push("Pending");
      result.push("warning");
    } else if (status === 1) {
      result.push("Approved");
      result.push("success");
    } else if (status === 2) {
      result.push("Resent");
      result.push("error");
    }
    return result;
  };
  const handleEditDepartment = (raiology, rep) => {
    console.log("REP", raiology, rep);
    navigate("/dashboard/lab/radiology", {
      state: {
        reportId: raiology._id,
        report: [rep],
        sentInvoice: {
          patientId: raiology.patientId,
          doctorId: raiology.doctorId,
          invoiceId: raiology.invoice,
          createdAt: raiology.createdAt,
        },
        reqType: "edit",
      },
    });
  };
  function formatDate(inputDate) {
    const dateObj = new Date(inputDate);
    const day = dateObj.getDate().toString().padStart(2, "0");
    const monthShort = dateObj.toLocaleString("default", { month: "short" });
    const yearShort = dateObj.getFullYear().toString().slice(-2);
    return `${day}-${monthShort}-${yearShort}`;
  }
  function formatTime(dateString) {
    const dateObj = new Date(dateString);
    let hours = dateObj.getHours();
    const minutes = dateObj.getMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12;
    hours = hours ? hours : 12; // '0' hour should be '12'
    const formattedHours = hours.toString().padStart(2, "0");

    return `${formattedHours}:${minutes} ${ampm}`;
  }
  console.log(444444, user?._doc?.organizationId?.orgID);
  let yPositionOriginalTop = 621.92; //560; // default for all was 621.92
  let yPositionOriginalBottom = 80; //90; // default for all was 80
  let yContentEnd = 85;
  let signaturePosition = 30;
  let headerBoxX = 10;
  let headerBoxInfoX = 25;
  let testNameBoxX = 10;
  let paddingLeft = "27px";

  //for testing
  // let yPositionOriginalTop = 560;
  // let yPositionOriginalBottom = 90;
  // let yContentEnd = 75;
  // let signaturePosition = 400;

  if (user?._doc?.organizationId?.orgID === "18-14") {
    yPositionOriginalTop = 600;
    yPositionOriginalBottom = 90;
    yContentEnd = 85;
    signaturePosition = 400;
    headerBoxX = 33;
    headerBoxInfoX = 35;
    testNameBoxX = 30;
    paddingLeft = "40px";
  } else if (user?._doc?.organizationId?.orgID === "18-12") {
    yPositionOriginalTop = 560;
    yPositionOriginalBottom = 90;
    yContentEnd = 85;
    signaturePosition = 400;
  } else if (user?._doc?.organizationId?.orgID === "18-2") {
    yPositionOriginalTop = 560;
    yPositionOriginalBottom = 90;
    yContentEnd = 85;
    signaturePosition = 400;
  }
  const addHeader1 = async (
    radiology,
    page,
    pageNumber,
    normalFont,
    boldFont,
    barcodeFont,
  ) => {
    //let yPosition = page.getHeight() - 220; // high value goes up, low value goes down.
    //console.log("YYYYYY", yPosition); // Initial default value is: page.getHeight() - 220 = 621.92
    let yPosition = yPositionOriginalTop; // 621.92
    const rightXPosition = 300;
    const rightXPosition2 = 380;
    const leftXPosition = 76;
    const pageWidth = page.getWidth();
    const patientFontSize = 11;
    const restFontSize = 9;
    // Header Background with Rounded Corners
    page.drawRectangle({
      x: headerBoxX, //for all 10
      y: yPosition + 10,
      width: pageWidth - 43, //for all 20
      height: 95,
      color: rgb(0.98, 0.98, 0.98), // Soft gray background
      borderColor: rgb(0.8, 0.8, 0.8),
      borderWidth: 0.7,
    });

    yPosition += 90;
    page.drawText(`${radiology.patientId.name}`, {
      x: headerBoxInfoX, //for all 25
      y: yPosition,
      size: patientFontSize,
      font: boldFont,
      color: rgb(0.2, 0.2, 0.2),
    });

    // Invoice ID
    page.drawText("UHID", {
      x: rightXPosition,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.1, 0.1, 0.1),
    });
    page.drawText(`: ${radiology.patientId.patientID}`, {
      x: rightXPosition2,
      y: yPosition,
      size: 11,
      font: boldFont,
      color: rgb(0.2, 0.2, 0.2),
    });

    yPosition -= 15;

    // Gender / Age
    page.drawText("Sex / Age", {
      x: headerBoxInfoX, //for all 25
      y: yPosition,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.1, 0.1, 0.1),
    });
    page.drawText(
      `: ${radiology.patientId.gender} / ${showAgeInReport(
        radiology.patientId.dob,
      )}`,
      {
        x: leftXPosition,
        y: yPosition,
        size: restFontSize,
        font: normalFont,
        color: rgb(0.2, 0.2, 0.2),
      },
    );

    page.drawText("Case ID", {
      x: rightXPosition,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.1, 0.1, 0.1),
    });
    page.drawText(`: ${radiology.invoice}`, {
      x: rightXPosition2,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.2, 0.2, 0.2),
    });

    // Mobile Number
    yPosition -= 15;
    page.drawText("Mobile", {
      x: headerBoxInfoX, //for all 25
      y: yPosition,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.1, 0.1, 0.1),
    });
    page.drawText(`: ${radiology.patientId.mobile}`, {
      x: leftXPosition,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.2, 0.2, 0.2),
    });

    page.drawText("Reg. Date", {
      x: rightXPosition,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.1, 0.1, 0.1),
    });
    page.drawText(
      `: ${formatDate(radiology.billingDate)} ${formatTime(
        radiology.billingTime,
      )}`,
      {
        x: rightXPosition2,
        y: yPosition,
        size: restFontSize,
        font: normalFont,
        color: rgb(0.2, 0.2, 0.2),
      },
    );

    // Referred By
    yPosition -= 15;
    page.drawText("Ref. By", {
      x: headerBoxInfoX, //for all 25
      y: yPosition,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.1, 0.1, 0.1),
    });
    page.drawText(`: ${radiology.doctorId.name}`, {
      x: leftXPosition,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.2, 0.2, 0.2),
    });
    page.drawText("Report Generated", {
      x: rightXPosition,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.1, 0.1, 0.1),
    });
    page.drawText(`: ${formatDateTime(radiology.createdAt)}`, {
      x: rightXPosition2,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.2, 0.2, 0.2),
    });

    // Center
    yPosition -= 15;
    page.drawText("Center", {
      x: headerBoxInfoX, //for all 25
      y: yPosition,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.1, 0.1, 0.1),
    });

    //vertical line
    page.drawLine({
      start: { x: 280, y: yPositionOriginalTop + 13.08 }, // Bottom point yPositionOriginalTop = 621.92, here y: 635
      end: { x: 280, y: yPositionOriginalTop + 98.08 }, // Top point (50px above), here y: 720
      thickness: 0.7,
      color: rgb(0.8, 0.8, 0.8),
    });
    page.drawLine({
      start: { x: 480, y: yPositionOriginalTop + 13.08 }, // Bottom point here y: 635
      end: { x: 480, y: yPositionOriginalTop + 98.08 }, // Top point (50px above) here y: 720
      thickness: 0.7,
      color: rgb(0.8, 0.8, 0.8),
    });
    page.drawText(`: ${radiology.centreId.centreId}`, {
      x: leftXPosition,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.2, 0.2, 0.2),
    });
    // page.drawText("*" + radiology.invoice + "*", {
    //   x: rightXPosition,
    //   y: yPosition - 15,
    //   size: 30,
    //   font: barcodeFont,
    // });
    const barcodeCanvas = document.createElement("canvas");
    JsBarcode(barcodeCanvas, radiology.invoice, {
      format: "CODE128",
      width: 2,
      height: 30,
      displayValue: false,
    });
    const barcodeImage = barcodeCanvas.toDataURL("image/png");
    const barcodeBytes = await fetch(barcodeImage).then((res) =>
      res.arrayBuffer(),
    );
    const barcodeImg = await page.doc.embedPng(barcodeBytes);
    page.drawImage(barcodeImg, {
      x: rightXPosition - 6,
      y: yPosition - 17,
      width: 180,
      height: 30,
    });

    yPosition -= 15;
    page.drawText("Lab ID", {
      x: headerBoxInfoX, //for all 25
      y: yPosition,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.1, 0.1, 0.1),
    });
    page.drawText(`: ${localStorage.getItem("orgID").replaceAll("-", ".")}`, {
      x: leftXPosition,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.2, 0.2, 0.2),
    });
  };

  const addHeader = async (
    radiology,
    page,
    pageNumber,
    normalFont,
    boldFont,
    barcodeFont,
  ) => {
    let yPosition = page.getHeight() - 220;
    let patientInfoX = 25;
    let headerBoxX = 10;
    let lineStartY = 635; // for all 635
    let lineEndY = 720; // for all 720
    let investigationHeaderLineX = 10; // for all 10
    let tableHeaderInvX = 14;
    if (user?._doc?.organizationId?.orgID === "18-1") {
      yPosition = page.getHeight() - 245;
      patientInfoX = 35;
      headerBoxX = 33;
      lineStartY = 610;
      lineEndY = 695;
      investigationHeaderLineX = 30;
      tableHeaderInvX = 33;
    }
    const headerFontSize = 10;
    const labelFontSize = 10;
    const rightXPosition = 300;
    const rightXPosition2 = 380;
    const leftXPosition = 76;
    const pageWidth = page.getWidth();
    const patientFontSize = 11;
    const restFontSize = 9;
    const pageHeight = page.getHeight();
    // Header Background with Rounded Corners
    let Y_POSITION = Number(pageHeight - radioLayout?.header?.position?.y);
    let X_POSITION_PATIENT_INFO = Number(radioLayout?.header?.position?.x);
    let X_POSITION_UHID = radioLayout?.header?.columns?.patient?.width;
    const CONTENT_WIDTH = radioLayout?.content?.size?.width;
    let CONTENT_Y = Number(pageHeight - radioLayout?.content?.position?.y);
    let CONTENT_X = Number(pageHeight - radioLayout?.content?.position?.x);

    page.drawRectangle({
      x: Number(radioLayout?.header?.position?.x), // for all 10,
      y: Y_POSITION - 95,
      width: Number(radioLayout?.header?.size?.width), // for all 20,
      height: Number(radioLayout?.header?.size?.height),
      color: rgb(0.98, 0.98, 0.98), // Soft gray background
      borderColor: rgb(0.8, 0.8, 0.8),
      borderWidth: 0.7,
    });

    yPosition += 90;
    Y_POSITION -= 15;

    page.drawText(`${radiology.patientId.name}`, {
      x: X_POSITION_PATIENT_INFO + 10, // for all 25,
      y: Y_POSITION,
      size: patientFontSize,
      font: boldFont,
      color: rgb(0.2, 0.2, 0.2),
    });

    // Invoice ID
    page.drawText("UHID", {
      x: X_POSITION_UHID + 10,
      y: Y_POSITION,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.1, 0.1, 0.1),
    });
    page.drawText(`: ${radiology.patientId.patientID}`, {
      x: X_POSITION_UHID + 100,
      y: Y_POSITION,
      size: 11,
      font: boldFont,
      color: rgb(0.2, 0.2, 0.2),
    });

    yPosition -= 15;
    Y_POSITION -= 15;
    // Gender / Age
    page.drawText("Sex / Age", {
      x: X_POSITION_PATIENT_INFO + 10, //for all 25,
      y: Y_POSITION,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.1, 0.1, 0.1),
    });
    page.drawText(
      `: ${radiology.patientId.gender} / ${showAgeInReport(
        radiology.patientId.dob,
      )}`,
      {
        x: X_POSITION_PATIENT_INFO + 50,
        y: Y_POSITION,
        size: restFontSize,
        font: normalFont,
        color: rgb(0.2, 0.2, 0.2),
      },
    );

    page.drawText("Case ID", {
      x: X_POSITION_UHID + 10,
      y: Y_POSITION,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.1, 0.1, 0.1),
    });
    page.drawText(`: ${radiology.invoice}`, {
      x: X_POSITION_UHID + 100,
      y: Y_POSITION,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.2, 0.2, 0.2),
    });

    // Mobile Number
    yPosition -= 15;
    Y_POSITION -= 15;
    page.drawText("Mobile", {
      x: X_POSITION_PATIENT_INFO + 10, //for all 25,
      y: Y_POSITION,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.1, 0.1, 0.1),
    });
    page.drawText(`: ${radiology.patientId.mobile}`, {
      x: X_POSITION_PATIENT_INFO + 50,
      y: Y_POSITION,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.2, 0.2, 0.2),
    });

    page.drawText("Reg. Date", {
      x: X_POSITION_UHID + 10,
      y: Y_POSITION,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.1, 0.1, 0.1),
    });
    page.drawText(
      `: ${formatDate(radiology.billingDate)} ${formatTime(
        radiology.billingTime,
      )}`,
      {
        x: X_POSITION_UHID + 100,
        y: Y_POSITION,
        size: restFontSize,
        font: normalFont,
        color: rgb(0.2, 0.2, 0.2),
      },
    );

    // Referred By
    yPosition -= 15;
    Y_POSITION -= 15;
    page.drawText("Ref. By", {
      x: X_POSITION_PATIENT_INFO + 10, //for all 25,
      y: Y_POSITION,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.1, 0.1, 0.1),
    });
    page.drawText(`: ${radiology.doctorId.name}`, {
      x: X_POSITION_PATIENT_INFO + 50,
      y: Y_POSITION,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.2, 0.2, 0.2),
    });

    page.drawText("Report Generated", {
      x: X_POSITION_UHID + 10,
      y: Y_POSITION,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.1, 0.1, 0.1),
    });
    page.drawText(`: ${formatDateTime(radiology.createdAt)}`, {
      x: X_POSITION_UHID + 100,
      y: Y_POSITION,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.2, 0.2, 0.2),
    });

    // Center
    yPosition -= 15;
    Y_POSITION -= 15;
    page.drawText("Center", {
      x: X_POSITION_PATIENT_INFO + 10, //for all 25,
      y: Y_POSITION,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.1, 0.1, 0.1),
    });

    page.drawLine({
      start: {
        x: Number(radioLayout?.header?.columns?.patient?.width),
        y: Number(pageHeight - radioLayout?.header?.position?.y) - 95,
      }, // was 635
      end: {
        x: radioLayout?.header?.columns?.patient?.width,
        y: Number(pageHeight - radioLayout?.header?.position?.y),
      }, // was 720
      thickness: 0.7,
      color: rgb(0.8, 0.8, 0.8),
    });

    page.drawText(`: ${radiology.centreId.centreId}`, {
      x: X_POSITION_PATIENT_INFO + 50,
      y: Y_POSITION,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.2, 0.2, 0.2),
    });
    const barcodeCanvas = document.createElement("canvas");
    JsBarcode(barcodeCanvas, radiology.invoice, {
      format: "CODE128",
      width: 2,
      height: 30,
      displayValue: false,
    });
    const barcodeImage = barcodeCanvas.toDataURL("image/png");
    const barcodeBytes = await fetch(barcodeImage).then((res) =>
      res.arrayBuffer(),
    );
    const barcodeImg = await page.doc.embedPng(barcodeBytes);
    page.drawImage(barcodeImg, {
      x: X_POSITION_UHID + 5,
      y: Y_POSITION - 17,
      width: 180,
      height: 30,
    });

    yPosition -= 15;
    Y_POSITION -= 15;
    page.drawText("Lab ID", {
      x: X_POSITION_PATIENT_INFO + 10, //for all 25,
      y: Y_POSITION,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.1, 0.1, 0.1),
    });
    page.drawText(`: ${localStorage.getItem("orgID").replaceAll("-", ".")}`, {
      x: X_POSITION_PATIENT_INFO + 50,
      y: Y_POSITION,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.2, 0.2, 0.2),
    });
  };

  // const handleGeneratePDF = async (radiology, report) => {
  //   try {
  //     const pdfTemplate =
  //       "https://res.cloudinary.com/dotuhpjuq/image/upload/v1740934598/org_PDFs/18_1/eoncocktxyx0tj2llsch.pdf";

  //     const templatePdfBytes = await fetch(pdfTemplate).then((res) =>
  //       res.arrayBuffer()
  //     );
  //     const templatePdf = await PDFDocument.load(templatePdfBytes);
  //     const pdfDoc = await PDFDocument.create();
  //     pdfDoc.registerFontkit(fontkit);

  //     const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
  //     const normalFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
  //     const fontBytes = await fetch(BarcodeFont).then((res) =>
  //       res.arrayBuffer()
  //     );
  //     const barcodeFont = await pdfDoc.embedFont(fontBytes);

  //     const addTemplatePage = async () => {
  //       const [templatePage] = await pdfDoc.copyPages(templatePdf, [0]);
  //       const newPage = pdfDoc.addPage(templatePage);
  //       // Call header on every page added
  //       addHeader(radiology, newPage, 1, normalFont, boldFont, barcodeFont);
  //       return newPage;
  //     };

  //     const { height } = templatePdf.getPage(0).getSize();

  //     function splitTextIntoLines(text, maxLineLength = 90) {
  //       const words = text.split(" ");
  //       const lines = [];
  //       let currentLine = "";

  //       for (let word of words) {
  //         if ((currentLine + word).length > maxLineLength) {
  //           lines.push(currentLine.trim());
  //           currentLine = word + " ";
  //         } else {
  //           currentLine += word + " ";
  //         }
  //       }
  //       if (currentLine.trim()) lines.push(currentLine.trim());
  //       return lines;
  //     }

  //     // --- First Page ---
  //     let page = await addTemplatePage();
  //     let y = height - 230;

  //     // Department Heading
  //     page.drawText(report.testDept || "Department", {
  //       x: 50,
  //       y,
  //       size: 12,
  //       font: boldFont,
  //     });
  //     y -= 30;

  //     const firstItem = report.items[0];
  //     if (firstItem) {
  //       page.drawText(firstItem.testId?.testName || "Test", {
  //         x: 50,
  //         y,
  //         size: 14,
  //         font: boldFont,
  //       });
  //       y -= 20;

  //       const investigations = firstItem.investigations?.filter(
  //         (inv) => inv.inuse
  //       );
  //       for (let inv of investigations) {
  //         const plainText = inv.testContent.replace(/<[^>]+>/g, "").trim();
  //         const lines = splitTextIntoLines(plainText, 90);

  //         for (let line of lines) {
  //           if (y < 60) {
  //             page = await addTemplatePage();
  //             y = height - 230;
  //           }
  //           page.drawText(line, {
  //             x: 60,
  //             y,
  //             size: 12,
  //             font: normalFont,
  //           });
  //           y -= 16;
  //         }
  //         y -= 10;
  //       }
  //     }

  //     // --- Remaining Items (each on a new page) ---
  //     for (let i = 1; i < report.items.length; i++) {
  //       let page = await addTemplatePage();
  //       let y = height - 230;

  //       const item = report.items[i];

  //       page.drawText(item.testId?.testName || "Test", {
  //         x: 50,
  //         y,
  //         size: 14,
  //         font: boldFont,
  //       });
  //       y -= 20;

  //       const investigations = item.investigations?.filter((inv) => inv.inuse);
  //       for (let inv of investigations) {
  //         const plainText = inv.testContent.replace(/<[^>]+>/g, "").trim();
  //         const lines = splitTextIntoLines(plainText, 90);

  //         for (let line of lines) {
  //           if (y < 60) {
  //             page = await addTemplatePage();
  //             y = height - 230;
  //           }
  //           page.drawText(line, {
  //             x: 60,
  //             y,
  //             size: 12,
  //             font: normalFont,
  //           });
  //           y -= 16;
  //         }
  //         y -= 10;
  //       }
  //     }

  //     const pdfBytes = await pdfDoc.save();
  //     const blob = new Blob([pdfBytes], { type: "application/pdf" });
  //     const url = URL.createObjectURL(blob);
  //     window.open(url, "_blank");
  //   } catch (error) {
  //     console.error("Error generating PDF:", error);
  //   }
  // };

  // const handleGeneratePDF1 = async (radiology, report) => {
  //   setUploadingRadiologyId({
  //     radiologyID: radiology._id,
  //     dept: report.testDept,
  //   });
  //   try {
  //     const templatePdfBytes = await fetch(pdfTemplate).then((res) =>
  //       res.arrayBuffer()
  //     );
  //     const templatePdf = await PDFDocument.load(templatePdfBytes);
  //     const pdfDoc = await PDFDocument.create();
  //     pdfDoc.registerFontkit(fontkit);

  //     const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
  //     const normalFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
  //     const fontBytes = await fetch(BarcodeFont).then((res) =>
  //       res.arrayBuffer()
  //     );
  //     const barcodeFont = await pdfDoc.embedFont(fontBytes);
  //     let yPosition = 550;
  //     const margin = 15;
  //     const maxWidth = 550;
  //     const fontSize = 12;
  //     const endText = "*** END OF REPORT ***";
  //     const endWidth = normalFont.widthOfTextAtSize(endText, 10);
  //     const addTemplatePage = async () => {
  //       const [templatePage] = await pdfDoc.copyPages(templatePdf, [0]);
  //       const newPage = pdfDoc.addPage(templatePage);
  //       addHeader(radiology, newPage, 1, normalFont, boldFont, barcodeFont);
  //       return newPage;
  //     };
  //     const { height } = templatePdf.getPage(0).getSize();
  //     function extractText(node, font, isUnderlined) {
  //       console.log("$$$$", font);
  //       let segments = [];

  //       if (node.nodeType === Node.TEXT_NODE) {
  //         segments.push({ text: node.nodeValue.trim(), font, isUnderlined });
  //       } else if (node.nodeType === Node.ELEMENT_NODE) {
  //         let newFont = font;
  //         let newUnderline = isUnderlined;

  //         if (node.tagName === "STRONG") newFont = boldFont;
  //         if (node.tagName === "U") newUnderline = true;

  //         node.childNodes.forEach((child) => {
  //           segments.push(...extractText(child, newFont, newUnderline));
  //         });
  //       }
  //       return segments;
  //     }
  //     let page = await addTemplatePage();
  //     let y = height - 230;
  //     const width = page.getWidth();
  //     page.drawRectangle({
  //       x: 10,
  //       y: y - 3,
  //       width: width - 20,
  //       height: 15,
  //       color: rgb(0.94, 0.94, 0.94),
  //     });
  //     const firstItem = report.items[0];
  //     const deptTextWidth = normalFont.widthOfTextAtSize(
  //       firstItem.testId?.testName,
  //       10
  //     );
  //     if (firstItem) {
  //       page.drawText(firstItem.testId?.testName || "Test", {
  //         x: (width - deptTextWidth) / 2,
  //         y,
  //         size: 14,
  //         font: boldFont,
  //         color: rgb(0.502, 0, 0.125),
  //       });
  //       const investigations = firstItem.investigations?.filter(
  //         (inv) => inv.inuse
  //       );
  //       for (let inv of investigations) {
  //         const htmlContent = inv.testContent;
  //         const parser = new DOMParser();
  //         const doc = parser.parseFromString(htmlContent, "text/html");
  //         yPosition = 590;
  //         const paragraphs = [];
  //         doc.body.querySelectorAll("p").forEach((p) => {
  //           const segments = extractText(p, normalFont, false);
  //           const fullText = segments
  //             .map((seg) => seg.text)
  //             .join(" ")
  //             .trim();
  //           if (fullText) paragraphs.push({ segments });
  //         });
  //         paragraphs.forEach(({ segments }) => {
  //           let xPosition = margin;

  //           segments.forEach(({ text, font, isUnderlined }) => {
  //             if (!text) return;

  //             const words = text.split(" ");
  //             words.forEach((word, index) => {
  //               const wordWithSpace =
  //                 index === words.length - 1 ? word : word + " ";
  //               const textWidth = font.widthOfTextAtSize(
  //                 wordWithSpace,
  //                 fontSize
  //               );

  //               if (xPosition + textWidth > margin + maxWidth) {
  //                 yPosition -= 14;
  //                 xPosition = margin;
  //               }

  //               page.drawText(wordWithSpace, {
  //                 x: xPosition,
  //                 y: yPosition,
  //                 size: fontSize,
  //                 font: font,
  //                 color: rgb(0, 0, 0),
  //               });

  //               if (isUnderlined) {
  //                 const lineWidth = font.widthOfTextAtSize(
  //                   wordWithSpace,
  //                   fontSize
  //                 );
  //                 page.drawLine({
  //                   start: { x: xPosition, y: yPosition - 2 },
  //                   end: { x: xPosition + lineWidth, y: yPosition - 2 },
  //                   thickness: 1,
  //                   color: rgb(0, 0, 0),
  //                 });
  //               }

  //               xPosition += textWidth;
  //             });
  //           });

  //           yPosition -= 24;
  //         });
  //         y -= 10;

  //         page.drawText(endText, {
  //           x: (width - endWidth) / 2,
  //           y: yPosition,
  //           size: fontSize,
  //           font: boldFont,
  //           color: rgb(0, 0, 0),
  //         });
  //       }
  //       const signatoryDoctor = firstItem?.testId?.doctorSignatory;
  //       let startSignPosition = margin;
  //       for (let i = 0; i < signatoryDoctor.length; i++) {
  //         if (signatoryDoctor[i]?.doctor.signwebLink !== "") {
  //           const imageResponse = await fetch(
  //             signatoryDoctor[i]?.doctor.signwebLink
  //           );
  //           const imageBuffer = await imageResponse.arrayBuffer();
  //           const contentType = imageResponse.headers.get("content-type");
  //           let pdfImage;
  //           if (contentType.includes("png") || contentType.includes("webp")) {
  //             pdfImage = await pdfDoc.embedPng(imageBuffer);
  //           } else if (
  //             contentType.includes("jpeg") ||
  //             contentType.includes("jpg")
  //           ) {
  //             pdfImage = await pdfDoc.embedJpg(imageBuffer);
  //           } else {
  //             console.warn("Unsupported image format, trying PNG conversion.");
  //             return;
  //           }
  //           const imgDims = pdfImage.scale(0.5);
  //           page.drawImage(pdfImage, {
  //             x: startSignPosition,
  //             y: 80,
  //             width: imgDims.width, //50,
  //             height: imgDims.height, // 50,
  //           });
  //         }
  //         let techSignHeaderY = 70;
  //         const techNoteLines =
  //           signatoryDoctor[i]?.doctor.signHeader.split(/\s{2,}/g);
  //         for (const line of techNoteLines) {
  //           page.drawText(`${line.trim()}`, {
  //             x: startSignPosition,
  //             y: techSignHeaderY - 2,
  //             size: 9,
  //           });
  //           techSignHeaderY -= 10;
  //         }
  //         startSignPosition += 100;
  //       }
  //     }

  //     for (let i = 1; i < report.items.length; i++) {
  //       let page = await addTemplatePage();
  //       let y = height - 230;
  //       yPosition = 590;
  //       const item = report.items[i];
  //       page.drawRectangle({
  //         x: 10,
  //         y: y - 3,
  //         width: width - 20,
  //         height: 15,
  //         color: rgb(0.94, 0.94, 0.94),
  //       });
  //       const TextWidth = normalFont.widthOfTextAtSize(
  //         item.testId?.testName,
  //         10
  //       );
  //       page.drawText(item.testId?.testName || "Test", {
  //         x: (width - TextWidth) / 2,
  //         y,
  //         size: 14,
  //         font: boldFont,
  //       });
  //       y -= 20;

  //       const investigations = item.investigations?.filter((inv) => inv.inuse);
  //       for (let inv of investigations) {
  //         const htmlContent = inv.testContent;
  //         const parser = new DOMParser();
  //         const doc = parser.parseFromString(htmlContent, "text/html");

  //         const paragraphs = [];
  //         doc.body.querySelectorAll("p").forEach((p) => {
  //           const segments = extractText(p, normalFont, false);
  //           const fullText = segments
  //             .map((seg) => seg.text)
  //             .join(" ")
  //             .trim();
  //           if (fullText) paragraphs.push({ segments });
  //         });
  //         paragraphs.forEach(({ segments }) => {
  //           let xPosition = margin;

  //           segments.forEach(({ text, font, isUnderlined }) => {
  //             if (!text) return;

  //             const words = text.split(" ");
  //             words.forEach((word, index) => {
  //               const wordWithSpace =
  //                 index === words.length - 1 ? word : word + " ";
  //               const textWidth = font.widthOfTextAtSize(
  //                 wordWithSpace,
  //                 fontSize
  //               );

  //               if (xPosition + textWidth > margin + maxWidth) {
  //                 yPosition -= 14;
  //                 xPosition = margin;
  //               }

  //               page.drawText(wordWithSpace, {
  //                 x: xPosition,
  //                 y: yPosition,
  //                 size: fontSize,
  //                 font: font,
  //                 color: rgb(0, 0, 0),
  //               });

  //               if (isUnderlined) {
  //                 const lineWidth = font.widthOfTextAtSize(
  //                   wordWithSpace,
  //                   fontSize
  //                 );
  //                 page.drawLine({
  //                   start: { x: xPosition, y: yPosition - 2 },
  //                   end: { x: xPosition + lineWidth, y: yPosition - 2 },
  //                   thickness: 1,
  //                   color: rgb(0, 0, 0),
  //                 });
  //               }

  //               xPosition += textWidth;
  //             });
  //           });

  //           yPosition -= 24;
  //         });

  //         y -= 10;
  //         page.drawText(endText, {
  //           x: (width - endWidth) / 2,
  //           y: yPosition,
  //           size: fontSize,
  //           font: boldFont,
  //           color: rgb(0, 0, 0),
  //         });
  //       }

  //       const signatoryDoctor = item?.testId?.doctorSignatory;
  //       let startSignPosition = margin;
  //       for (let i = 0; i < signatoryDoctor.length; i++) {
  //         if (signatoryDoctor[i]?.doctor.signwebLink !== "") {
  //           const imageResponse = await fetch(
  //             signatoryDoctor[i]?.doctor.signwebLink
  //           );
  //           const imageBuffer = await imageResponse.arrayBuffer();
  //           const contentType = imageResponse.headers.get("content-type");
  //           let pdfImage;
  //           if (contentType.includes("png") || contentType.includes("webp")) {
  //             pdfImage = await pdfDoc.embedPng(imageBuffer);
  //           } else if (
  //             contentType.includes("jpeg") ||
  //             contentType.includes("jpg")
  //           ) {
  //             pdfImage = await pdfDoc.embedJpg(imageBuffer);
  //           } else {
  //             console.warn("Unsupported image format, trying PNG conversion.");
  //             return;
  //           }
  //           const imgDims = pdfImage.scale(0.5);
  //           page.drawImage(pdfImage, {
  //             x: startSignPosition,
  //             y: 80,
  //             width: imgDims.width, //50,
  //             height: imgDims.height, // 50,
  //           });
  //         }
  //         let techSignHeaderY = 70;
  //         const techNoteLines =
  //           signatoryDoctor[i]?.doctor.signHeader.split(/\s{2,}/g);
  //         for (const line of techNoteLines) {
  //           page.drawText(`${line.trim()}`, {
  //             x: startSignPosition,
  //             y: techSignHeaderY - 2,
  //             size: 9,
  //           });
  //           techSignHeaderY -= 10;
  //         }
  //         startSignPosition += 100;
  //       }
  //     }

  //     const pages = pdfDoc.getPages();
  //     for (let page of pages) {
  //       page.drawText("This is a verified report", {
  //         x: 500,
  //         y: 650,
  //         font: normalFont,
  //         size: 7,
  //       });
  //       const imageResponse = await fetch(verifyImg);
  //       const imageBuffer = await imageResponse.arrayBuffer();
  //       let Image = await pdfDoc.embedPng(imageBuffer);
  //       console.log("IIII", Image);
  //       page.drawImage(Image, {
  //         x: 513,
  //         y: 660,
  //         width: 50,
  //         height: 50,
  //       });
  //     }

  //     const pdfBytes1 = await pdfDoc.save();
  //     const blob1 = new Blob([pdfBytes1], { type: "application/pdf" });
  //     const url1 = URL.createObjectURL(blob1);
  //     window.open(url1, "_blank");
  //     return;
  //     const pdfBytes = await pdfDoc.save();
  //     const blob = new Blob([pdfBytes], { type: "application/pdf" });
  //     const file = new File([blob], "report.pdf", { type: "application/pdf" });
  //     const formData = new FormData();
  //     formData.append("pdfFile", file);
  //     formData.append("testDept", report.testDept);
  //     // return;
  //     try {
  //       const response = await fetch(
  //         `${BASE_URL}api/user/radiology/upload-radiology-report/${radiology._id}`,
  //         {
  //           method: "POST",
  //           headers: {
  //           },
  //           body: formData,
  //         }
  //       );

  //       if (!response.ok) {
  //         throw new Error("Failed to upload PDF");
  //       }
  //       const result = await response.json();
  //       console.log("Upload successful:", result);
  //       if (result.success) {
  //         alert(result.message);
  //         setRadiologies((prevRadiologies) =>
  //           prevRadiologies.map((r) => {
  //             if (r._id === radiology._id) {
  //               return {
  //                 ...r,
  //                 reportFileUrls: result.data.reportFileUrls,
  //               };
  //             }
  //             return r;
  //           })
  //         );
  //       }
  //     } catch (error) {
  //       console.error("Error uploading PDF:", error);
  //     }
  //   } catch (error) {
  //     console.error("Error generating PDF:", error);
  //   } finally {
  //     setUploadingRadiologyId(null);
  //   }
  // };

  const [loadingPreview, setLoadingPreview] = useState(false);
  const [loadingUpload, setLoadingUpload] = useState(false);

  //Original without dynamic
  const handleGeneratePDF0 = async (
    radiology,
    report,
    template = 1,
    preview = false,
  ) => {
    if (preview) {
      setLoadingPreview(true);
    } else {
      setLoadingUpload(true);
    }
    setUploadingRadiologyId({
      radiologyID: radiology._id,
      dept: report.testDept,
    });
    let pdfUrl;
    if (template === 0) {
      pdfUrl = blankA4;
    } else {
      pdfUrl = `${pdfTemplate}`;
    }
    try {
      const templatePdfBytes = await fetch(pdfUrl).then((res) =>
        res.arrayBuffer(),
      );
      const templatePdf = await PDFDocument.load(templatePdfBytes);
      const pdfDoc = await PDFDocument.create();
      pdfDoc.registerFontkit(fontkit);

      const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
      const normalFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
      const fontBytes = await fetch(BarcodeFont).then((res) =>
        res.arrayBuffer(),
      );
      const barcodeFont = await pdfDoc.embedFont(fontBytes);

      const margin = 15;
      const maxWidth = 550;
      const fontSize = 12;
      const endText = "*** END OF REPORT ***";
      const endWidth = normalFont.widthOfTextAtSize(endText, 10);
      const { height, width } = templatePdf.getPage(0).getSize();

      const addTemplatePage = async (item) => {
        const [templatePage] = await pdfDoc.copyPages(templatePdf, [0]);
        const newPage = pdfDoc.addPage(templatePage);
        addHeader(radiology, newPage, 1, normalFont, boldFont, barcodeFont);
        const signatoryDoctor = item?.testId?.doctorSignatory;
        let startSignPosition = signaturePosition; // 25
        for (let i = 0; i < signatoryDoctor?.length; i++) {
          if (signatoryDoctor[i]?.doctor.signwebLink !== "") {
            const imageResponse = await fetch(
              signatoryDoctor[i]?.doctor.signwebLink,
            );
            const imageBuffer = await imageResponse.arrayBuffer();
            const contentType = imageResponse.headers.get("content-type");
            let pdfImage;
            if (contentType.includes("png") || contentType.includes("webp")) {
              pdfImage = await pdfDoc.embedPng(imageBuffer);
            } else if (
              contentType.includes("jpeg") ||
              contentType.includes("jpg")
            ) {
              pdfImage = await pdfDoc.embedJpg(imageBuffer);
            } else {
              console.warn("Unsupported image format, trying PNG conversion.");
              return;
            }
            const imgDims = pdfImage.scale(0.5);
            newPage.drawImage(pdfImage, {
              x: signaturePosition,
              y: yPositionOriginalBottom, // here y: 90 yPositionOriginalTop = 621.92
              width: imgDims.width + 5, //50,
              height: imgDims.height + 5, // 50,
            });
          }
          let techSignHeaderY = yPositionOriginalBottom - 10; // here y is 80
          const techNoteLines =
            signatoryDoctor[i]?.doctor.signHeader.split(/\s{2,}/g);
          for (const line of techNoteLines) {
            newPage.drawText(`${line.trim()}`, {
              x: signaturePosition,
              y: techSignHeaderY,
              size: 11,
            });
            techSignHeaderY -= 10;
          }
          startSignPosition += 115;
        }
        return newPage;
      };

      //using this
      const generatePageContent = async (page, item) => {
        // our yPositionOriginalTop = 621.92;
        let y = yPositionOriginalTop - 9.67; //here y is height - 230 = 612.2499787 appox 612.25
        console.log("PAGE CONTENT----", y);
        let yPosition = yPositionOriginalTop - 31.92; // here y is 590

        page.drawRectangle({
          x: testNameBoxX, // for all 10
          y: y - 3,
          width: width - 40,
          height: 15,
          color: rgb(0.94, 0.94, 0.94),
        });

        const titleWidth = normalFont.widthOfTextAtSize(
          item.testId?.testName || "Test",
          10,
        );
        const pageWidth = page.getWidth() - 25;
        page.drawText(item.testId?.testName || "Test", {
          x: (pageWidth - titleWidth) / 2,
          y,
          size: 12,
          font: boldFont,
          color: rgb(0.502, 0, 0.125),
        });

        const investigations = item.investigations?.filter((inv) => inv.inuse);

        for (let inv of investigations) {
          const htmlContent = inv.testContent;

          const tempDiv = document.createElement("div");
          tempDiv.id = "RQ";
          tempDiv.style.position = "absolute";
          tempDiv.style.top = "-9999px";
          tempDiv.style.left = "-9999px";
          tempDiv.style.width = "1000px";
          tempDiv.style.margin = "0";
          tempDiv.style.padding = "0";
          tempDiv.style.paddingBottom = "20px";
          tempDiv.style.paddingLeft = paddingLeft; // 27px
          tempDiv.style.border = "none";
          tempDiv.style.boxSizing = "border-box";

          const styleTag = document.createElement("style");
          //small font-size: 15px
          //medium font-size: 18px
          //large font-size: 21px
          const fontSize = fontSizeMap[size];
          styleTag.textContent = `
                    #RQ {
                      margin: 0;
                      font-size: ${fontSize}px !important;
                      font-family: Arial, sans-serif;
                      white-space: pre-wrap;
                    }
                      #RQ p, #RQ div{
                        white-space: pre-wrap;
                        margin-bottom: -5px;
                      }
                    .ql-align-center {
                      text-align: center;
                    }
                    .ql-align-right {
                      text-align: right;
                    }
                    .ql-align-left {
                      text-align: left;
                    }
                    strong {
                      font-weight: bold;
                    }
                    u {
                      text-decoration: underline;
                    }
                    #RQ table {
                      border-collapse: collapse;
                      width: 100%;
                    }
                    #RQ table td, #RQ table th {
                      border: 1px solid #000;
                      padding: 0px 6px 15px 6px
                    }
                    #RQ table p,
                    #RQ table div {
                      margin-bottom: 0 !important;
                      line-height: 1.4 !important;
                    }
                  `;
          // Append style and content separately
          tempDiv.appendChild(styleTag);
          appendSanitizedReportHtml(tempDiv, htmlContent);
          document.body.appendChild(tempDiv);
          const canvas = await html2canvas(tempDiv, {
            backgroundColor: null, //"lightblue",
            scale: 3,
            scrollX: 0,
            scrollY: 0,
            useCORS: true,
          });
          document.body.removeChild(tempDiv);
          const imgData = canvas.toDataURL("image/png");
          const pngImage = await pdfDoc.embedPng(imgData);
          const pngDims = pngImage.scale(0.9); //c
          const targetScale = (width - 100) / pngDims.width;
          const pageAvailableHeight =
            yPositionOriginalTop - yPositionOriginalBottom - yContentEnd; //yPosition - 220; // 308
          console.log("pageAvailableHeight", pageAvailableHeight);
          const singlePageCanvasHeight = pageAvailableHeight / targetScale;
          let startY = 0;
          let totalHeight = canvas.height;
          let currentPage = page;
          let currentY = yPosition;

          while (startY < totalHeight) {
            const sliceHeight = Math.min(
              singlePageCanvasHeight,
              totalHeight - startY,
            );

            // Create a sliced canvas
            const splitCanvas = document.createElement("canvas");
            splitCanvas.width = canvas.width;
            splitCanvas.height = sliceHeight;

            const splitCtx = splitCanvas.getContext("2d");

            splitCtx.drawImage(
              canvas,
              0,
              startY, // source x,y
              canvas.width,
              sliceHeight, // source width, height
              0,
              0, // destination x,y
              canvas.width,
              sliceHeight, // destination width, height
            );

            const splitImgData = splitCanvas.toDataURL("image/png");
            const splitPngImage = await pdfDoc.embedPng(splitImgData);
            const splitDims = splitPngImage.scale(targetScale);

            // Draw the image onto the PDF page
            currentPage.drawImage(splitPngImage, {
              x: Math.max(margin - 20, 10),
              y: currentY - splitDims.height + 20,
              width: splitDims.width,
              height: splitDims.height,
            });

            startY += sliceHeight;

            // If there is still more content to draw
            if (startY < totalHeight) {
              currentPage = await addTemplatePage(item); // create new page
              currentY = yPosition; // reset to top for new page
            } else {
              // if it's the last slice
              currentY -= splitDims.height + 20;
            }
          }

          y -= 10; // gap after each investigation
        }
      };

      let page = await addTemplatePage(report.items[0]);
      await generatePageContent(page, report.items[0]);

      // Remaining pages
      for (let i = 1; i < report.items.length; i++) {
        let newPage = await addTemplatePage(report.items[i]);
        await generatePageContent(newPage, report.items[i]);
      }

      const pages = pdfDoc.getPages();
      for (let page of pages) {
        page.drawText("This is a verified report", {
          x: 500,
          y: yPositionOriginalTop + 28.08, // here y: 650
          font: normalFont,
          size: 7,
        });
        const imageResponse = await fetch(verifyImg);
        const imageBuffer = await imageResponse.arrayBuffer();
        let Image = await pdfDoc.embedPng(imageBuffer);
        console.log("IIII", Image);
        page.drawImage(Image, {
          x: 513,
          y: yPositionOriginalTop + 38.08, //here y: 660
          width: 50,
          height: 50,
        });
      }

      const totalPages = pdfDoc.getPageCount();
      pdfDoc.getPages().forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${totalPages}`, {
          x: width - 50,
          y: 38,
          size: 8,
          color: rgb(0, 0, 0), // Black color
        });
      });

      if (template === 0) {
        // Generate QR Code
        const qrCodeDataUrl = await QRCode.toDataURL(report.url, {
          margin: 0,
        });
        const qrImageBytes = await fetch(qrCodeDataUrl).then((res) =>
          res.arrayBuffer(),
        );
        const qrImage = await pdfDoc.embedPng(qrImageBytes);

        // Embed QR Code in all pages
        const pages = pdfDoc.getPages();
        pages.forEach((page) => {
          page.drawImage(qrImage, {
            x: 500,
            y: yPositionOriginalTop + 25, // Adjust Y position (bottom of the page)
            width: 71,
            height: 65,
          });
        });

        const pdfBytes = await pdfDoc.save();
        const blob = new Blob([pdfBytes], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        window.open(url, "_blank");
        return;
      }

      if (preview) {
        const pdfBytes1 = await pdfDoc.save();
        const blob1 = new Blob([pdfBytes1], { type: "application/pdf" });
        const url1 = URL.createObjectURL(blob1);
        window.open(url1, "_blank");
        setLoadingPreview(false);
        return;
      }
      const pdfBytes = await pdfDoc.save();
      const blob = new Blob([pdfBytes], { type: "application/pdf" });
      const file = new File([blob], "report.pdf", {
        type: "application/pdf",
      });
      const formData = new FormData();
      formData.append("pdfFile", file);
      formData.append("testDept", report.testDept);
      try {
        const response = await fetch(
          `${BASE_URL}api/user/radiology/upload-radiology-report/${radiology._id}`,
          {
            method: "POST",
            headers: {},
            body: formData,
          },
        );

        if (!response.ok) {
          throw new Error("Failed to upload PDF");
        }
        const result = await response.json();
        console.log("Upload successful:", result);
        if (result.success) {
          alert(result.message);
          setRadiologyReport((prevRadiologies) =>
            prevRadiologies.map((r) => {
              if (r._id === radiology._id) {
                return {
                  ...r,
                  reportFileUrls: result.data.reportFileUrls,
                };
              }
              return r;
            }),
          );
        }
      } catch (error) {
        console.error("Error uploading PDF:", error);
      }
    } catch (error) {
      console.error("Error generating PDF:", error);
    } finally {
      setUploadingRadiologyId(null);
      setLoadingPreview(false);
      setLoadingUpload(false);
      setRowLoading(false);
      if (!preview) {
        setOpen(false);
      }
    }
  };

  const handleGeneratePDF = async (
    radiology,
    report,
    template = 1,
    preview = false,
  ) => {
    if (preview) {
      setLoadingPreview(true);
    } else {
      setLoadingUpload(true);
    }
    setUploadingRadiologyId({
      radiologyID: radiology._id,
      dept: report.testDept,
    });
    let pdfUrl;
    if (template === 0) {
      pdfUrl = blankA4;
    } else {
      pdfUrl = `${pdfTemplate}`;
    }
    try {
      const templatePdfBytes = await fetch(pdfUrl).then((res) =>
        res.arrayBuffer(),
      );
      const templatePdf = await PDFDocument.load(templatePdfBytes);
      const pdfDoc = await PDFDocument.create();
      pdfDoc.registerFontkit(fontkit);

      const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
      const normalFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
      const fontBytes = await fetch(BarcodeFont).then((res) =>
        res.arrayBuffer(),
      );
      const barcodeFont = await pdfDoc.embedFont(fontBytes);

      const margin = 15;
      const maxWidth = 550;
      const fontSize = 12;
      const endText = "*** END OF REPORT ***";
      const endWidth = normalFont.widthOfTextAtSize(endText, 10);
      const { height, width } = templatePdf.getPage(0).getSize();

      const addTemplatePage = async (item) => {
        const [templatePage] = await pdfDoc.copyPages(templatePdf, [0]);
        const newPage = pdfDoc.addPage(templatePage);
        addHeader(radiology, newPage, 1, normalFont, boldFont, barcodeFont);

        const pageHeight = newPage.getHeight();
        const doctorPos = radioLayout?.footer?.doctorSignature?.position;

        const signatoryDoctor = item?.testId?.doctorSignatory;
        let startSignPosition = signaturePosition;

        for (let i = 0; i < signatoryDoctor?.length; i++) {
          let x = signaturePosition;
          let y = yPositionOriginalBottom;

          if (signatoryDoctor[i]?.doctor.signwebLink !== "") {
            const imageResponse = await fetch(
              signatoryDoctor[i]?.doctor.signwebLink,
            );
            const imageBuffer = await imageResponse.arrayBuffer();
            const contentType = imageResponse.headers.get("content-type");

            let pdfImage;
            if (contentType.includes("png") || contentType.includes("webp")) {
              pdfImage = await pdfDoc.embedPng(imageBuffer);
            } else if (
              contentType.includes("jpeg") ||
              contentType.includes("jpg")
            ) {
              pdfImage = await pdfDoc.embedJpg(imageBuffer);
            } else {
              console.warn("Unsupported image format, trying PNG conversion.");
              return;
            }

            const imgDims = pdfImage.scale(0.5);

            if (doctorPos) {
              x = doctorPos.x;
              y = pageHeight - doctorPos.y - imgDims.height;
            }

            newPage.drawImage(pdfImage, {
              x: x,
              y: y,
              width: imgDims.width + 5,
              height: imgDims.height + 5,
            });
          }

          let docSignHeaderY =
            pageHeight - radioLayout?.footer?.doctorSignature?.position?.y; //y - 10;

          const docNoteLines =
            signatoryDoctor[i]?.doctor.signHeader.split(/\s{2,}/g);

          for (const line of docNoteLines) {
            newPage.drawText(`${line.trim()}`, {
              x: radioLayout?.footer?.doctorSignature?.position?.x,
              y: docSignHeaderY,
              size: 11,
            });
            docSignHeaderY -= 10;
          }

          startSignPosition += 115;
        }

        return newPage;
      };

      const generatePageContent = async (page, item) => {
        const pageHeight = page.getHeight();

        // ================================
        // 🔹 HEADER (DYNAMIC)
        // ================================
        const headerY = radioLayout?.header?.position?.y || 0;
        const headerHeight = radioLayout?.header?.size?.height || 100;
        const contentY = Number(
          pageHeight - radioLayout?.content?.position?.y - 10,
        ); //radioLayout?.content?.position?.y;

        const headerTopY = pageHeight - headerY;
        const headerBottomY = headerTopY - headerHeight;

        // ================================
        // 🔥 CONTENT START (DYNAMIC)
        // ================================
        //const HEADER_CONTENT_GAP = 25; // 🔥 adjustable spacing

        const contentStartY = contentY; //headerBottomY; //- HEADER_CONTENT_GAP;

        let y = contentStartY;
        // let yPosition = contentStartY - 25;
        let yPosition = contentStartY - 15;

        // ================================
        // 🔹 CONTENT BOX (DYNAMIC)
        // ================================
        const contentX = radioLayout?.content?.position?.x || 20;

        const contentWidth =
          radioLayout?.content?.size?.width || page.getWidth() - 40;

        const contentHeight =
          radioLayout?.content?.size?.height ||
          headerBottomY - yPositionOriginalBottom - 20;

        // ================================
        // 🔹 TITLE BACKGROUND
        // ================================
        page.drawRectangle({
          x: contentX,
          y: y - 3,
          width: contentWidth,
          height: 15,
          color: rgb(0.94, 0.94, 0.94),
        });

        const title = item.testId?.testName || "Test";

        const titleWidth = normalFont.widthOfTextAtSize(title, 10);

        page.drawText(title, {
          x: contentX + (contentWidth - titleWidth) / 2,
          y,
          size: 12,
          font: boldFont,
          color: rgb(0.502, 0, 0.125),
        });

        // ================================
        // 🔹 INVESTIGATIONS CONTENT
        // ================================
        const investigations = item.investigations?.filter((inv) => inv.inuse);

        for (let inv of investigations) {
          const htmlContent = inv.testContent;

          // 🔹 TEMP DOM
          const tempDiv = document.createElement("div");
          tempDiv.id = "RQ";
          tempDiv.style.position = "absolute";
          tempDiv.style.top = "-9999px";
          tempDiv.style.left = "-9999px";
          tempDiv.style.width = "1000px";
          tempDiv.style.margin = "0";
          tempDiv.style.padding = "0";
          tempDiv.style.paddingBottom = "20px";
          tempDiv.style.border = "none";
          tempDiv.style.boxSizing = "border-box";

          const styleTag = document.createElement("style");
          const fontSize = fontSizeMap[size];

          styleTag.textContent = `
      #RQ {
        margin: 0;
        font-size: ${fontSize}px !important;
        font-family: Arial, sans-serif;
        white-space: pre-wrap;
      }
      #RQ p, #RQ div {
        margin-bottom: -5px;
      }
      #RQ .ql-size-large{
        font-size: ${fontSize + 2}px !important;
      } 
      #RQ table {
        border-collapse: collapse;
        width: 100%;
      }
      #RQ table td, #RQ table th {
        border: 1px solid #000;
        padding: 0px 6px 15px 6px;
      }
    `;

          tempDiv.appendChild(styleTag);
          appendSanitizedReportHtml(tempDiv, htmlContent);
          document.body.appendChild(tempDiv);

          const canvas = await html2canvas(tempDiv, {
            backgroundColor: null,
            scale: 3,
            useCORS: true,
          });

          document.body.removeChild(tempDiv);

          const imgData = canvas.toDataURL("image/png");
          const pngImage = await pdfDoc.embedPng(imgData);
          const pngDims = pngImage.scale(1);

          // ================================
          // 🔥 SCALING
          // ================================
          const originalScale = (page.getWidth() - 100) / pngDims.width;
          const targetScale =
            originalScale * (contentWidth / (page.getWidth() - 100));

          const pageAvailableHeight = contentHeight;
          const singlePageCanvasHeight = pageAvailableHeight / targetScale;

          let startY = 0;
          let totalHeight = canvas.height;
          let currentPage = page;
          let currentY = yPosition;

          // ================================
          // 🔥 MULTI-PAGE SPLIT
          // ================================
          while (startY < totalHeight) {
            const sliceHeight = Math.min(
              singlePageCanvasHeight,
              totalHeight - startY,
            );

            const splitCanvas = document.createElement("canvas");
            splitCanvas.width = canvas.width;
            splitCanvas.height = sliceHeight;

            const ctx = splitCanvas.getContext("2d");

            ctx.drawImage(
              canvas,
              0,
              startY,
              canvas.width,
              sliceHeight,
              0,
              0,
              canvas.width,
              sliceHeight,
            );

            const splitImgData = splitCanvas.toDataURL("image/png");
            const splitImage = await pdfDoc.embedPng(splitImgData);
            const splitDims = splitImage.scale(targetScale);

            currentPage.drawImage(splitImage, {
              x: contentX,
              //y: currentY - splitDims.height + 20,
              y: currentY - splitDims.height,
              width: splitDims.width,
              height: splitDims.height,
            });

            startY += sliceHeight;

            if (startY < totalHeight) {
              currentPage = await addTemplatePage(item);

              // 🔥 RESET POSITION FOR NEW PAGE
              const newPageHeight = currentPage.getHeight();
              const headerTopY2 = newPageHeight - headerY;
              const headerBottomY2 = headerTopY2 - headerHeight;

              currentY = headerBottomY2 - 25;
            } else {
              currentY -= splitDims.height + 20;
            }
          }

          y -= 10;
        }
      };

      let page = await addTemplatePage(report.items[0]);
      await generatePageContent(page, report.items[0]);

      for (let i = 1; i < report.items.length; i++) {
        let newPage = await addTemplatePage(report.items[i]);
        await generatePageContent(newPage, report.items[i]);
      }

      // ✅ Embed verify image once (outside loop ideally)
      const imageResponse = await fetch(verifyImg);
      const imageBuffer = await imageResponse.arrayBuffer();
      const verifyImage = await pdfDoc.embedPng(imageBuffer);

      const pages = pdfDoc.getPages();

      const qrImgWidth = 71;
      const qrImgHeight = 65;

      const verifyImgWidth = 50;
      const verifyImgHeight = 50;
      const textSize = 6;
      const gap = 4;

      pages.forEach((page) => {
        const pageHeight = page.getHeight();

        // 🔹 Layout values (same as QR)
        const headerX = radioLayout.header.position.x;
        const headerY = radioLayout.header.position.y;
        const headerHeight = radioLayout.header.size.height;

        const patientW = radioLayout.header.columns.patient.width;
        const uhidW = radioLayout.header.columns.uhid.width;
        const qrW = radioLayout.header.columns.qr.width;

        // 🔹 QR column start
        const qrBoxLeftX = headerX + patientW + uhidW;

        // 🔹 Center X
        const centerX = qrBoxLeftX + qrW / 2;

        // 🔹 Header Y conversion
        const headerTopY = pageHeight - headerY;
        const headerBottomY = headerTopY - headerHeight;

        const centerY = headerBottomY + headerHeight / 2;

        // 🔥 TOTAL BLOCK (image + text)
        const totalHeight = verifyImgHeight + gap + textSize;

        const blockBottomY = centerY - totalHeight / 2;

        // 🔹 Image X centered
        const imageX = centerX - verifyImgWidth / 2;

        // 🔹 Draw image
        page.drawImage(verifyImage, {
          x: imageX,
          y: blockBottomY + textSize + gap,
          width: verifyImgWidth,
          height: verifyImgHeight,
        });

        // 🔹 Draw text centered
        const text = "This is a verified report";
        const textWidth = normalFont.widthOfTextAtSize(text, textSize);

        page.drawText(text, {
          x: centerX - textWidth / 2,
          y: blockBottomY,
          size: textSize,
          font: normalFont,
        });
      });

      const totalPages = pdfDoc.getPageCount();
      pdfDoc.getPages().forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${totalPages}`, {
          x: width - 50,
          y: 38,
          size: 8,
          color: rgb(0, 0, 0),
        });
      });

      if (template === 0) {
        const qrCodeDataUrl = await QRCode.toDataURL(report.url, {
          margin: 0,
        });

        const qrImageBytes = await fetch(qrCodeDataUrl).then((res) =>
          res.arrayBuffer(),
        );

        const qrImage = await pdfDoc.embedPng(qrImageBytes);

        const pages = pdfDoc.getPages();

        const qrImgWidth = 71;
        const qrImgHeight = 65;

        pages.forEach((page) => {
          const pageHeight = page.getHeight();

          // ✅ Layout config (same as viewReport)
          const headerX = radioLayout.header.position.x;
          const headerY = radioLayout.header.position.y;
          const headerHeight = radioLayout.header.size.height;

          const patientW = radioLayout.header.columns.patient.width;
          const uhidW = radioLayout.header.columns.uhid.width;
          const qrW = radioLayout.header.columns.qr.width;

          // 🔑 QR column left edge
          const qrBoxLeftX = headerX + patientW + uhidW;

          // 🔑 Center horizontally
          const qrX = qrBoxLeftX + (qrW - qrImgWidth) / 2;

          // 🔑 Convert Y (pdf-lib origin bottom-left)
          const headerTopY = pageHeight - headerY;
          const headerBottomY = headerTopY - headerHeight;

          // 🔑 Vertical center
          const qrY = headerBottomY + headerHeight / 2 - qrImgHeight / 2;

          // ✅ Draw QR
          page.drawImage(qrImage, {
            x: qrX,
            y: qrY,
            width: qrImgWidth,
            height: qrImgHeight,
          });
        });

        const pdfBytes = await pdfDoc.save();
        const blob = new Blob([pdfBytes], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        window.open(url, "_blank");
        return;
      }

      // const pdfBytes1 = await pdfDoc.save();
      // const blob1 = new Blob([pdfBytes1], { type: "application/pdf" });
      // const url1 = URL.createObjectURL(blob1);
      // window.open(url1, "_blank");
      // return;

      if (preview) {
        const pdfBytes1 = await pdfDoc.save();
        const blob1 = new Blob([pdfBytes1], { type: "application/pdf" });
        const url1 = URL.createObjectURL(blob1);
        window.open(url1, "_blank");
        setLoadingPreview(false);
        return;
      }

      const pdfBytes = await pdfDoc.save();
      const blob = new Blob([pdfBytes], { type: "application/pdf" });
      const file = new File([blob], "report.pdf", {
        type: "application/pdf",
      });
      const formData = new FormData();
      formData.append("pdfFile", file);
      formData.append("testDept", report.testDept);
      try {
        const response = await fetch(
          `${BASE_URL}api/user/radiology/upload-radiology-report/${radiology._id}`,
          {
            method: "POST",
            headers: {},
            body: formData,
          },
        );

        const result = await response.json(); // ✅ always parse response

        if (!response.ok) {
          // 🔥 Show backend message (due / permission error)
          throw new Error(result.message || "Failed to upload PDF");
        }

        console.log("Upload successful:", result);

        if (result.success) {
          alert(result.message);

          setRadiologyReport((prevRadiologies) =>
            prevRadiologies.map((r) => {
              if (r._id === radiology._id) {
                return {
                  ...r,
                  reportFileUrls: result.data.reportFileUrls,
                };
              }
              return r;
            }),
          );
        }
      } catch (error) {
        console.error("Error uploading PDF:", error);

        // 🔥 Show exact error (like due payment message)
        alert(error.message);
      }
    } catch (error) {
      console.error("Error generating PDF:", error);
    } finally {
      setUploadingRadiologyId(null);
      setLoadingPreview(false);
      setLoadingUpload(false);
      setRowLoading(false);
      if (!preview) {
        setOpen(false);
      }
    }
  };

  const viewReport1 = async (radiology, report, file) => {
    try {
      setUploadingRadiologyId({
        radiologyID: radiology._id,
        dept: report.testDept,
      });
      // Fetch the PDF from the URL
      const response = await fetch(file);
      if (!response.ok) throw new Error("Failed to fetch PDF");

      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      // Generate QR Code
      const qrCodeDataUrl = await QRCode.toDataURL(file, {
        margin: 0,
      });
      const qrImageBytes = await fetch(qrCodeDataUrl).then((res) =>
        res.arrayBuffer(),
      );
      const qrImage = await pdfDoc.embedPng(qrImageBytes);

      // Embed QR Code in all pages
      const pages = pdfDoc.getPages();
      pages.forEach((page) => {
        page.drawImage(qrImage, {
          x: 500,
          y:
            user?._doc?.organizationId?.orgID === "18-14"
              ? 620
              : yPositionOriginalTop + 25, //yPositionOriginalTop + 25, // Adjust Y position (bottom of the page)
          width: 71,
          height: 65,
        });
      });

      // Save the modified PDF
      const updatedPdfBytes = await pdfDoc.save();
      const blob = new Blob([updatedPdfBytes], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);
      // logPrintReport(radiology._id);
      // Open the modified PDF in a new tab
      window.open(blobUrl, "_blank");
    } catch (error) {
      console.error("Error fetching or processing PDF:", error);
      alert("Failed to load the report. Please try again.");
    } finally {
      setUploadingRadiologyId(null);
    }
  };

  const viewReport = async (radiology, report, fileUrl) => {
    try {
      setUploadingRadiologyId({
        radiologyID: radiology._id,
        dept: report.testDept,
      });

      // ✅ Fetch PDF
      const response = await fetch(fileUrl);
      if (!response.ok) throw new Error("Failed to fetch PDF");

      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      // ✅ Generate QR
      const qrCodeDataUrl = await QRCode.toDataURL(fileUrl, { margin: 0 });
      const qrImageBytes = await fetch(qrCodeDataUrl).then((res) =>
        res.arrayBuffer(),
      );
      const qrImage = await pdfDoc.embedPng(qrImageBytes);

      const pages = pdfDoc.getPages();

      const qrImgWidth = 71;
      const qrImgHeight = 65;

      pages.forEach((page) => {
        const pageHeight = page.getHeight();

        // ✅ Layout config (same pattern as pathology)
        const headerX = radioLayout.header.position.x;
        const headerY = radioLayout.header.position.y;
        const headerHeight = radioLayout.header.size.height;

        const patientW = radioLayout.header.columns.patient.width;
        const uhidW = radioLayout.header.columns.uhid.width;
        const qrW = radioLayout.header.columns.qr.width;

        // 🔑 QR column left edge
        const qrBoxLeftX = headerX + patientW + uhidW;

        // 🔑 Center horizontally
        const qrX = qrBoxLeftX + (qrW - qrImgWidth) / 2;

        // 🔑 Convert Y (pdf-lib origin bottom-left)
        const headerTopY = pageHeight - headerY;
        const headerBottomY = headerTopY - headerHeight;

        // 🔑 Vertical center
        const qrY = headerBottomY + headerHeight / 2 - qrImgHeight / 2;

        // ✅ Draw QR
        page.drawImage(qrImage, {
          x: qrX,
          y: qrY,
          width: qrImgWidth,
          height: qrImgHeight,
        });
      });

      // ✅ Save & Open
      const updatedPdfBytes = await pdfDoc.save();
      const blob = new Blob([updatedPdfBytes], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);

      // logPrintReport(radiology._id);
      window.open(blobUrl, "_blank");
    } catch (error) {
      console.error("Error fetching or processing PDF:", error);
      alert("Failed to load the report. Please try again.");
    } finally {
      setUploadingRadiologyId(null);
    }
  };
  return (
    <Box>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 4,
            overflow: "hidden",
            background: "linear-gradient(145deg, #ffffff, #f5f6fa)",
            boxShadow:
              "0 8px 30px rgba(0,0,0,0.08), inset 0 1px 1px rgba(255,255,255,0.6)",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            fontWeight: 700,
            fontSize: 20,
            px: 3,
            py: 2.5,
            borderBottom: "1px solid #e5e7eb",
          }}
        >
          <FormatSizeIcon
            sx={{ fontSize: 26, color: "primary.main", opacity: 0.9 }}
          />
          Select Report Font Size
        </DialogTitle>

        <DialogContent
          sx={{
            px: 3,
            py: 3,
          }}
        >
          <Typography variant="body2" sx={{ mb: 2, mt: 2, color: "#555" }}>
            Choose how large you want the printed text to appear on the final
            report.
          </Typography>

          <FormControl fullWidth>
            <RadioGroup
              value={size}
              onChange={(e) => setSize(e.target.value)}
              sx={{
                gap: 1,
                "& .MuiFormControlLabel-root": {
                  borderRadius: 2,
                  px: 1,
                  py: 0.5,
                  transition: "0.2s",
                },
                "& .MuiFormControlLabel-root:hover": {
                  backgroundColor: "#f1f5fb",
                },
              }}
            >
              <FormControlLabel
                value="small"
                control={<Radio />}
                label="Small"
                onClick={() => setSize("small")}
              />
              <FormControlLabel
                value="medium"
                control={<Radio />}
                label="Medium"
                onClick={() => setSize("medium")}
              />
              <FormControlLabel
                value="large"
                control={<Radio />}
                label="Large"
                onClick={() => setSize("large")}
              />
            </RadioGroup>
          </FormControl>
        </DialogContent>

        <DialogActions
          sx={{
            px: 3,
            py: 2.5,
            borderTop: "1px solid #e5e7eb",
            gap: 2,
          }}
        >
          <Button
            variant="outlined"
            startIcon={<VisibilityIcon />}
            disabled={loadingPreview}
            sx={{
              borderRadius: 2.5,
              px: 3,
              textTransform: "none",
              borderWidth: 2,
              "&:hover": { borderWidth: 2 },
            }}
            onClick={() =>
              handleGeneratePDF(
                selectedRadiologyToUpload,
                selectedReportToUpload,
                1,
                true,
              )
            }
          >
            {loadingPreview ? "Loading..." : "Preview"}
          </Button>

          <Button
            variant="contained"
            startIcon={<CloudUploadIcon />}
            disabled={loadingUpload}
            sx={{
              borderRadius: 2.5,
              px: 3,
              textTransform: "none",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            }}
            onClick={() =>
              handleGeneratePDF(
                selectedRadiologyToUpload,
                selectedReportToUpload,
              )
            }
          >
            {loadingUpload ? "Uploading..." : "Upload"}
          </Button>
        </DialogActions>
      </Dialog>
      <TableContainer
        component={Paper}
        elevation={3}
        sx={{
          borderRadius: "16px",
          overflow: "hidden",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginTop: 2,
              marginLeft: 5,
            }}
          >
            <Typography>From: </Typography>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => {
                setFromDate(e.target.value); // Store in YYYY-MM-DD for input
                setFormattedFromDate(
                  formatDateToReadableString(e.target.value),
                ); // Store in readable format
              }}
              style={{
                // width: "100%",
                padding: "6px 8px",
                fontSize: "14px",
                borderRadius: "6px",
                border: "1px solid #ddd",
                outline: "none",
                transition: "all 0.3s ease-in-out",
                boxShadow: "inset 0 1px 3px rgba(0, 0, 0, 0.1)",
                marginRight: 5,
              }}
            />
            <Typography>To: </Typography>
            <input
              type="date"
              value={toDate} // Bind with the correct format for the input
              onChange={(e) => {
                setToDate(e.target.value); // Store in YYYY-MM-DD for input
                setFormattedToDate(formatDateToReadableString(e.target.value)); // Store in readable format
              }}
              style={{
                // width: "100%",
                padding: "6px 8px",
                fontSize: "14px",
                borderRadius: "6px",
                border: "1px solid #ddd",
                outline: "none",
                transition: "all 0.3s ease-in-out",
                boxShadow: "inset 0 1px 3px rgba(0, 0, 0, 0.1)",
              }}
            />
            {fromDate && toDate && (
              <ContentPasteSearchIcon
                onClick={fetchAllRadiology}
                sx={{ fontSize: "2rem", color: "#ef2d56", cursor: "pointer" }}
              />
            )}
          </div>
          {paginatedRadiologies && (
            <TablePagination
              component="div"
              count={totalCount}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </Box>
        {/* Search and Reload */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 1,
          }}
        >
          <Chip
            avatar={
              <Avatar
                sx={{
                  backgroundColor: "#d0f0c0",
                  color: "#000",
                }}
              >
                {totalCount}
              </Avatar>
            }
            label="radiology"
            color="success"
          />
          <TextField
            placeholder="Search radiology"
            variant="outlined"
            size="small"
            value={searchQuery}
            onChange={handleSearch}
            sx={{
              width: "20%",
              ml: "auto",
            }}
          />
          <button
            onClick={handleReload}
            style={{
              display: "flex",
              alignItems: "center",
              border: "none",
              background: "none",
              cursor: "pointer",
              padding: "8px",
            }}
          >
            <RefreshIcon style={{ color: "#1976d2", fontSize: "24px" }} />
          </button>
        </Box>

        {/* <Table>
          <TableHead
            sx={{
              backgroundColor: "#d9e2ff",
              "& .MuiTableCell-head": {
                fontWeight: "bold",
                fontSize: "14px",
                color: "#5c6bc0",
                textTransform: "uppercase",
              },
            }}
          >
            <TableRow>
              <TableCell>Invoice ID</TableCell>
              <TableCell>Patient Name</TableCell>
              <TableCell>Doctor Name</TableCell>
              <TableCell>Actions</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedRadiologies?.map((radiology, index) => (
              <TableRow
                key={index}
                sx={{
                  "&:hover": {
                    backgroundColor: "#f1f8ff",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  },
                  transition:
                    "background-color 0.2s ease, box-shadow 0.2s ease",
                }}
              >
                <TableCell>{radiology.invoice}</TableCell>
                <TableCell>{radiology.patientId.name}</TableCell>
                <TableCell>{radiology.doctorId.name}</TableCell>
                <TableCell>
                  {user?._doc?.permissions?.radiologyManagement?.edit && (
                    <Tooltip title="Edit Report" arrow placement="top">
                      <IconButton size="small">
                        <EditIcon
                          color="primary"
                          sx={{ cursor: "pointer" }}
                          //onClick={() => handleEdit(radiology)}
                        />
                      </IconButton>
                    </Tooltip>
                  )}
                  {radiology.reportFileUrl?.length === 0 ? (
                    radiology.overallStatus === 1 ? (
                      !loadingStates[radiology._id] ? (
                        <Tooltip title="Upload Report" arrow placement="top">
                          <IconButton size="small">
                            <UploadFileIcon
                              color="success"
                              sx={{ cursor: "pointer" }}
                              //   onClick={() => handlePrint(radiology.reportFileUrl)}
                              onClick={() => handleGeneratePDF(radiology)}
                            />
                          </IconButton>
                        </Tooltip>
                      ) : (
                        <IconButton size="small">
                          <CircularProgress color="success" size={24} />
                        </IconButton>
                      )
                    ) : (
                      ""
                    )
                  ) : !loadingStates[radiology._id] ? (
                    <>
                      <Tooltip
                        title="Print with template"
                        arrow
                        placement="top"
                      >
                        <IconButton
                          size="small"
                          //onClick={() => viewReport(radiology)}
                        >
                          <NoteAddIcon sx={{ color: "#2a9d8f" }} size={24} />
                        </IconButton>
                      </Tooltip>

                      <Tooltip
                        title="Print without template"
                        arrow
                        placement="top"
                      >
                        <IconButton
                          size="small"
                          //onClick={() => handleGeneratePDF(radiology, 0)}
                        >
                          <ContentCopyIcon
                            sx={{ color: "#e63946" }}
                            size={24}
                          />
                        </IconButton>
                      </Tooltip>
                    </>
                  ) : (
                    <IconButton size="small">
                      <CircularProgress color="success" size={24} />
                    </IconButton>
                  )}
                </TableCell>
                <TableCell>
                  <Tooltip
                    title={getColorTitle(radiology.overallStatus)[0]}
                    arrow
                    placement="right"
                    // open
                  >
                    <IconButton>
                      <CircleIcon
                        color={getColorTitle(radiology.overallStatus)[1]}
                        sx={{ cursor: "pointer", fontSize: "15px" }}
                      />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table> */}
        {/* <Table>
          <TableHead
            sx={{
              backgroundColor: "#d9e2ff",
              "& .MuiTableCell-head": {
                fontWeight: "bold",
                fontSize: "14px",
                color: "#5c6bc0",
                textTransform: "uppercase",
              },
            }}
          >
            <TableRow>
              <TableCell>Invoice ID</TableCell>
              <TableCell>Patient Name</TableCell>
              <TableCell>Doctor Name</TableCell>
              <TableCell>Test Department</TableCell> 
              <TableCell>Actions</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedRadiologies?.map((radiology, index) => (
              <TableRow
                key={index}
                sx={{
                  "&:hover": {
                    backgroundColor: "#f1f8ff",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  },
                  transition:
                    "background-color 0.2s ease, box-shadow 0.2s ease",
                }}
              >
                <TableCell>{radiology.invoice}</TableCell>
                <TableCell>{radiology.patientId.name}</TableCell>
                <TableCell>{radiology.doctorId.name}</TableCell>
                <TableCell>
                  {radiology.report?.map((rep, i) => (
                    <div key={i}>{rep?.testId?._id?.testDept || "N/A"}</div>
                  ))}
                </TableCell>
                <TableCell>
                  {user?._doc?.permissions?.radiologyManagement?.edit && (
                    <Tooltip title="Edit Report" arrow placement="top">
                      <IconButton size="small">
                        <EditIcon
                          color="primary"
                          sx={{ cursor: "pointer" }}
                          // onClick={() => handleEdit(radiology)}
                        />
                      </IconButton>
                    </Tooltip>
                  )}
                  {radiology.reportFileUrl?.length === 0 ? (
                    radiology.overallStatus === 1 ? (
                      !loadingStates[radiology._id] ? (
                        <Tooltip title="Upload Report" arrow placement="top">
                          <IconButton size="small">
                            <UploadFileIcon
                              color="success"
                              sx={{ cursor: "pointer" }}
                              onClick={() => handleGeneratePDF(radiology)}
                            />
                          </IconButton>
                        </Tooltip>
                      ) : (
                        <IconButton size="small">
                          <CircularProgress color="success" size={24} />
                        </IconButton>
                      )
                    ) : (
                      ""
                    )
                  ) : !loadingStates[radiology._id] ? (
                    <>
                      <Tooltip
                        title="Print with template"
                        arrow
                        placement="top"
                      >
                        <IconButton size="small">
                          <NoteAddIcon sx={{ color: "#2a9d8f" }} size={24} />
                        </IconButton>
                      </Tooltip>

                      <Tooltip
                        title="Print without template"
                        arrow
                        placement="top"
                      >
                        <IconButton size="small">
                          <ContentCopyIcon
                            sx={{ color: "#e63946" }}
                            size={24}
                          />
                        </IconButton>
                      </Tooltip>
                    </>
                  ) : (
                    <IconButton size="small">
                      <CircularProgress color="success" size={24} />
                    </IconButton>
                  )}
                </TableCell>
                <TableCell>
                  <Tooltip
                    title={getColorTitle(radiology.overallStatus)[0]}
                    arrow
                    placement="right"
                  >
                    <IconButton>
                      <CircleIcon
                        color={getColorTitle(radiology.overallStatus)[1]}
                        sx={{ cursor: "pointer", fontSize: "15px" }}
                      />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table> */}
        <Table>
          {/* Table Head */}
          <TableHead
            sx={{
              backgroundColor: "#d9e2ff",
              "& .MuiTableCell-head": {
                fontWeight: "bold",
                fontSize: "14px",
                color: "#5c6bc0",
                textTransform: "uppercase",
              },
            }}
          >
            <TableRow>
              <TableCell>Invoice ID</TableCell>
              <TableCell>Patient Name</TableCell>
              <TableCell>Doctor Name</TableCell>
              <TableCell
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <span>Department</span>
                <span>Actions</span>
              </TableCell>
              {/* <TableCell>Actions</TableCell> */}
            </TableRow>
            {rowLoading && (
              <TableRow>
                <TableCell colSpan={4} sx={{ padding: 0 }}>
                  <LinearProgress
                    color="success"
                    sx={{ height: 2, width: "100%" }}
                  />
                </TableCell>
              </TableRow>
            )}
          </TableHead>

          {/* Table Body */}
          <TableBody>
            {console.log("PPPAAGGGIII", paginatedRadiologies)}
            {paginatedRadiologies?.map((radiology, index) => (
              <TableRow
                key={index}
                sx={{
                  "&:hover": {
                    backgroundColor: "#f1f8ff",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  },
                  transition:
                    "background-color 0.2s ease, box-shadow 0.2s ease",
                }}
              >
                <TableCell>{radiology.invoice}</TableCell>
                <TableCell>{radiology.patientId.name}</TableCell>
                <TableCell>{radiology.doctorId.name}</TableCell>
                <TableCell>
                  {radiology.report?.map((rep, i) => {
                    const testDept = rep?.testDept || "N/A";
                    const hasFile = rep?.url;

                    return (
                      <Box
                        key={i}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          borderBottom: "1px solid #eee",
                          py: 1,
                        }}
                      >
                        <Typography variant="body2" sx={{ flex: 1 }}>
                          {testDept}
                        </Typography>

                        <Box sx={{ display: "flex", gap: 1 }}>
                          {user?._doc?.permissions?.radiologyManagement
                            ?.edit && (
                            <Tooltip title="Edit Report" arrow placement="top">
                              <IconButton
                                size="small"
                                onClick={() =>
                                  handleEditDepartment(radiology, rep)
                                }
                              >
                                <EditIcon color="primary" />
                              </IconButton>
                            </Tooltip>
                          )}
                          {!hasFile ? (
                            <Tooltip
                              title="Upload Report"
                              arrow
                              placement="top"
                            >
                              <IconButton
                                size="small"
                                onClick={() => {
                                  setSelectedRadiologyToUpload(radiology);
                                  setSelectedReportToUpload(rep);
                                  setOpen(true);
                                }}
                                disabled={
                                  uploadingRadiologyId?.radiologyID ===
                                    radiology._id &&
                                  uploadingRadiologyId?.dept === testDept
                                }
                              >
                                {uploadingRadiologyId?.radiologyID ===
                                  radiology._id &&
                                uploadingRadiologyId?.dept === testDept ? (
                                  <CircularProgress size={24} color="success" />
                                ) : (
                                  <UploadFileIcon color="success" />
                                )}
                              </IconButton>
                            </Tooltip>
                          ) : (
                            <>
                              <Tooltip
                                title="Print with Template"
                                arrow
                                placement="top"
                              >
                                <IconButton
                                  size="small"
                                  onClick={() =>
                                    viewReport(radiology, rep, hasFile)
                                  }
                                  disabled={
                                    uploadingRadiologyId?.radiologyID ===
                                      radiology._id &&
                                    uploadingRadiologyId?.dept === testDept
                                  }
                                >
                                  {uploadingRadiologyId?.radiologyID ===
                                    radiology._id &&
                                  uploadingRadiologyId?.dept === testDept ? (
                                    <CircularProgress
                                      size={24}
                                      color="success"
                                    />
                                  ) : (
                                    <NoteAddIcon
                                      sx={{ color: "#2a9d8f" }}
                                      size={24}
                                    />
                                  )}
                                </IconButton>
                              </Tooltip>
                              <Tooltip
                                title="Print without Template"
                                arrow
                                placement="top"
                              >
                                <IconButton
                                  size="small"
                                  onClick={() =>
                                    handleGeneratePDF(radiology, rep, 0)
                                  }
                                  disabled={
                                    uploadingRadiologyId?.radiologyID ===
                                      radiology._id &&
                                    uploadingRadiologyId?.dept === testDept
                                  }
                                >
                                  {uploadingRadiologyId?.radiologyID ===
                                    radiology._id &&
                                  uploadingRadiologyId?.dept === testDept ? (
                                    <CircularProgress
                                      size={24}
                                      color="success"
                                    />
                                  ) : (
                                    <ContentCopyIcon
                                      sx={{ color: "#e63946" }}
                                      size={24}
                                    />
                                  )}
                                </IconButton>
                              </Tooltip>
                            </>
                          )}
                        </Box>
                      </Box>
                    );
                  })}
                </TableCell>
              </TableRow>
            ))}
            {paginatedRadiologies.length === 0 && (
              <TableRow>
                <TableCell colSpan={5} sx={{ padding: 0 }}>
                  <img
                    src={noData}
                    style={{ margin: "auto" }}
                    width="50%"
                    height="50%"
                  />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        {/* Drawer */}
        <Drawer
          anchor="right"
          open={isDrawerOpen}
          onClose={handleCloseDrawer}
          PaperProps={{
            sx: {
              width: "70vw",
              height: "50vh",
              padding: 2,
              marginTop: "150px",
              borderTopLeftRadius: "20px",
              borderBottomLeftRadius: "20px",
            },
          }}
        >
          <Box
            display="flex"
            flexDirection="column"
            gap={2}
            height="100%"
            justifyContent="space-between"
          >
            <div>
              <Typography variant="h4" sx={{ mb: 5 }}>
                Edit radiology
              </Typography>
              {selectedPatient && (
                <>
                  <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        label="ID"
                        fullWidth
                        value={selectedPatient.patientID}
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        label="Name"
                        fullWidth
                        value={selectedPatient.name}
                        onChange={(e) =>
                          setSelectedPatient({
                            ...selectedPatient,
                            name: e.target.value,
                          })
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      {/* <TextField
                        label="Age"
                        fullWidth
                        value={selectedPatient.age}
                      /> */}
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <FormControl
                          sx={{ flex: 2, marginRight: 1 }}
                          // error={!!errors?.dob}
                        >
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <Box sx={{ position: "relative", width: "100%" }}>
                              {/* Tooltip with Age */}
                              {selectedPatient?.dob && (
                                <Tooltip
                                  title={
                                    <Typography variant="body2" color="inherit">
                                      {calculateAge(selectedPatient.dob)}
                                    </Typography>
                                  }
                                  open // Always visible
                                  placement="top"
                                  arrow
                                ></Tooltip>
                              )}
                              <DatePicker
                                label="Date of Birth"
                                size="small"
                                sx={{
                                  width: "100%",
                                }}
                                onChange={handleDateChange}
                                format="DD-MM-YYYY"
                                maxDate={dayjs()}
                                value={
                                  selectedPatient.dob
                                    ? dayjs(selectedPatient.dob, "DD-MM-YYYY")
                                    : null
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    sx={{ padding: 0 }}
                                    fullWidth
                                    // error={!!errors?.dob}
                                  />
                                )}
                              />
                            </Box>
                          </LocalizationProvider>
                        </FormControl>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Typography
                            sx={{
                              backgroundColor: "#ececec",
                              borderRadius: "50%",
                              padding: 1,
                              // border: !!errors?.dob && "1px solid red",
                            }}
                          >
                            OR
                          </Typography>
                          {/* <FormHelperText>{errors.dob}</FormHelperText> */}
                        </Box>
                        <TextField
                          label="Age"
                          variant="outlined"
                          type="age"
                          name="age"
                          sx={{ flex: 1, marginLeft: 1 }}
                          onChange={handleAgeChange}
                          value={selectedPatient.age}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12} sm={4}>
                      {/* <TextField
                        label="Gender"
                        fullWidth
                        value={selectedPatient.gender}
                      /> */}
                      <FormControl fullWidth>
                        <Select
                          value={selectedPatient.gender || ""}
                          onChange={(e) =>
                            setSelectedPatient({
                              ...selectedPatient,
                              gender: e.target.value,
                            })
                          }
                          name="gender"
                          displayEmpty
                          variant="outlined"
                        >
                          <MenuItem value="" disabled>
                            Select Gender
                          </MenuItem>
                          <MenuItem value="Male">Male</MenuItem>
                          <MenuItem value="Female">Female</MenuItem>
                          <MenuItem value="Others">Others</MenuItem>
                        </Select>
                        {/* <FormHelperText>{errors.gender}</FormHelperText> */}
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        label="Mobile"
                        fullWidth
                        value={selectedPatient.mobile}
                        onChange={(e) =>
                          setSelectedPatient({
                            ...selectedPatient,
                            mobile: e.target.value,
                          })
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        label="Address"
                        fullWidth
                        value={selectedPatient.address}
                        onChange={(e) =>
                          setSelectedPatient({
                            ...selectedPatient,
                            address: e.target.value,
                          })
                        }
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        label="Aadhar (Optional)"
                        fullWidth
                        value={selectedPatient.aadhar}
                        onChange={(e) =>
                          setSelectedPatient({
                            ...selectedPatient,
                            aadhar: e.target.value,
                          })
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Autocomplete
                        options={doctors}
                        getOptionLabel={(option) => {
                          return `${option.name || ""} ${
                            option.regId ? option.regId : ""
                          }`;
                        }}
                        value={selectedPatient.refDoctor}
                        onChange={(event, newValue) =>
                          setSelectedPatient({
                            ...selectedPatient,
                            refDoctor: newValue,
                          })
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select Doctor"
                            variant="outlined"
                            fullWidth
                            // error={!!errors.refDoctor}
                            // helperText={errors.refDoctor}
                          />
                        )}
                        isOptionEqualToValue={(option, value) =>
                          option.id === value.id
                        }
                        disableClearable
                        filterOptions={(options, state) => {
                          const filtered = options.slice(0, 5);
                          if (state.inputValue) {
                            return options.filter((option) => {
                              const label = `${option.name || ""} ${
                                option.regId || ""
                              }`;
                              return label
                                .toLowerCase()
                                .includes(state.inputValue.toLowerCase());
                            });
                          }

                          return filtered; // Return the first 5 options if no input
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      {/* <TextField
                        label="Ref. Center"
                        fullWidth
                        value={selectedPatient.refCenter}
                      /> */}
                      <Autocomplete
                        options={centers}
                        getOptionLabel={(option) => {
                          return `${option.centreName || ""} ${
                            option.centreId ? `- ${option.centreId}` : ""
                          }`;
                        }}
                        value={selectedPatient.refCenter}
                        onChange={(event, newValue) =>
                          setSelectedPatient({
                            ...selectedPatient,
                            refCenter: newValue,
                          })
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select Center"
                            variant="outlined"
                            fullWidth
                            // error={!!errors.refCenter}
                            // helperText={errors.refCenter}
                          />
                        )}
                        isOptionEqualToValue={(option, value) =>
                          option.id === value.id
                        }
                        disableClearable
                        filterOptions={(options, state) => {
                          const filtered = options.slice(0, 5); // Limit to the first 5 options by default
                          if (state.inputValue) {
                            return options.filter((option) => {
                              const label = `${option.centreName || ""} ${
                                option.centreId || ""
                              }`;
                              return label
                                .toLowerCase()
                                .includes(state.inputValue.toLowerCase());
                            });
                          }
                          return filtered; // Return the first 5 options if no input
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Box>
                    <Button
                      variant="contained"
                      color="warning"
                      sx={{ width: "100%", marginTop: 2 }}
                      onClick={handleSubmitEdit}
                    >
                      Edit
                    </Button>
                  </Box>
                </>
              )}
            </div>
          </Box>
        </Drawer>

        {/* Pagination */}
        {/* <TablePagination
          component="div"
          count={filteredRadiologies.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        /> */}
      </TableContainer>
    </Box>
  );
};

export default RadiologyReports;
